/* eslint-disable prettier/prettier */
import { useMemo } from 'react';
import { usePersonalRoomList, useRoomListLoading } from 'shared-state/directory/hooks';
import { sortRoomList } from './helpers';

export interface PersonalRoomListState {
    personalRoomIds: string[];
    isPersonalRoomsLoading: boolean;
}
const usePersonalRoomListState: () => PersonalRoomListState = () => {
    const personalRooms = usePersonalRoomList();
    const [isPersonalRoomsLoading] = useRoomListLoading();
    const personalRoomIds = useMemo(() => {
        return sortRoomList(personalRooms).map((r: any) => r.id);
    }, [personalRooms]);

    return {
        personalRoomIds,
        isPersonalRoomsLoading
    };
};

export default usePersonalRoomListState;
